import React,{Component} from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Link
} from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './store';
import Loadable from 'react-loadable';

// component

// import HomePage from './containers/Home';
// import InfluencerPage from './containers/Influencer';
// import PricingPage from './containers/Pricing';
// import CirclePage from './containers/Circle';
// import FeaturesPage from './containers/Features';
// import ContactPage from './containers/Contact';
// import AboutUs from './containers/Aboutus';
// import Terms from './containers/Terms';
// import Login from './containers/Login';
// import SignUp from './containers/SignUp';

// import SignUp from './containers/Guide';
// import GuideSub from './containers/Guide/sub';
// import GuideDetail from './containers/Guide/show';

const store = configureStore();

const Loading = () => <div className="pace"></div>;

const HomePage = Loadable({
    loader: () => import('./containers/Home'),
    // loader: () => import('./containers/Maintenance'),
    loading: Loading
})

const InfluencerPage = Loadable({
    loader: () => import('./containers/Influencer'),
    loading: Loading
})

const PricingPage = Loadable({
    loader: () => import('./containers/Pricing'),
    loading: Loading
})
const CirclePage = Loadable({
    loader: () => import('./containers/Circle'),
    loading: Loading
})
const WinnerPage = Loadable({
    loader: () => import('./containers/Circle/winner'),
    loading: Loading
})
const FeaturesPage = Loadable({
    loader: () => import('./containers/Features'),
    loading: Loading
})
const ContactPage = Loadable({
    loader: () => import('./containers/Contact'),
    loading: Loading
})
const AboutUs = Loadable({
    loader: () => import('./containers/AboutUs'),
    loading: Loading
})
const Terms = Loadable({
    loader: () => import('./containers/Terms'),
    loading: Loading
})

const OfficialStatement = Loadable({
    loader: () => import('./containers/OfficialStatement'),
    loading: Loading
})

const Login = Loadable({
    loader: () => import('./containers/Login'),
    loading: Loading
})
const LoginForgot = Loadable({
    loader: () => import('./containers/Login/forgot'),
    loading: Loading
})


const LoginReset = Loadable({
    loader: () => import('./containers/Login/reset'),
    loading: Loading
})

const LoginResetSuccess = Loadable({
    loader: () => import('./containers/Login/resetSuccess'),
    loading: Loading
})

const LoginResetComplete = Loadable({
    loader: () => import('./containers/Login/complete'),
    loading: Loading
})

const SignUp = Loadable({
    loader: () => import('./containers/SignUp'),
    loading: Loading
})

const SignUpActivation = Loadable({
    loader: () => import('./containers/SignUp/activation'),
    loading: Loading
})

const SignUpSuccess = Loadable({
    loader: () => import('./containers/SignUp/success'),
    loading: Loading
})

const SignUpComplete = Loadable({
    loader: () => import('./containers/SignUp/complete'),
    loading: Loading
})

const Guide = Loadable({
    loader: () => import('./containers/Guide'),
    loading: Loading
})
const GuideSub = Loadable({
    loader: () => import('./containers/Guide/sub'),
    loading: Loading
})

const GuideShow = Loadable({
    loader: () => import('./containers/Guide/show'),
    loading: Loading
})

const removeStorage = () => {
    localStorage.clear();
    window.location.href = window.location.href
}

const CheckUrl = () => {
    var getLocation = undefined;
    var urlName = ['advertiser', 'influencer']

    for(let i = 0; i < urlName.length; i++){
        getLocation = window.location.href.match(urlName[i])
        console.log(getLocation)
        if(getLocation && getLocation.length) break

    }            
    return (getLocation && getLocation.length >= 1) ? 
    <React.Fragment>
        {/* <div>Try remove Storage</div>  */}
        <Link to="/"><button className="btn btn-default bg-blue">Back To Home</button></Link>
    </React.Fragment>
    :<div>Page Not Found 404</div> 
}

const NoMatch = ({}) => (
    <div className="no-match">
        <div>Oops Samething Error</div>        
        <CheckUrl />                
    </div>
)


class RouteGuest extends Component{
    componentDidMount(){
        const {dispatch} = this.props
        dispatch({
            type: 'LOGIN_DETAIL',
            data: JSON.parse(localStorage.getItem('auth'))
        })
    }
    render(){        
        return(                
            <Router >
                <div>
                <Switch>                       
                    <Route exact path="/" component={HomePage}/>

                    {/* <Route exact  path="/1273v126" component={Login}/> */}
                    <Route exact path="/im-influencer" component={InfluencerPage}/>
                    <Route exact path="/Features" component={FeaturesPage}/>
                    <Route exact path="/pricing" component={PricingPage}/>
                    <Route exact path="/awards" component={CirclePage}/>
                    <Route exact path="/awards/winner" component={WinnerPage}/>

                    <Route exact path="/guide" component={Guide}/>
                    <Route exact path="/guide/:name" component={GuideSub}/>
                    <Route exact path="/guide/:name/:show" component={GuideShow}/>

                    <Route exact path="/signup" component={SignUp}/>
                    <Route exact path="/signup/activation/:code" component={SignUpActivation}/>
                    <Route exact  path="/signup/success" component={SignUpSuccess}/>
                    <Route exact  path="/signup/complete/" component={SignUpComplete}/>                        
                    <Route exact  path="/login" component={Login}/>
                    <Route exact  path="/login/forgot" component={LoginForgot}/>
                    <Route exact  path="/login/reset/:token" component={LoginReset}/>
                    <Route exact  path="/login/complete" component={LoginResetComplete}/>
                    <Route exact  path="/login/forgot/success" component={LoginResetSuccess}/>
                    <Route exact  path="/about-us" component={AboutUs}/>
                    <Route exact  path="/contact" component={ContactPage}/>
                    <Route exact  path="/terms-and-conditions" component={Terms}/>
                    <Route exact  path="/official-statement" component={OfficialStatement}/>                   
                    <Route exact component={NoMatch} />
                    </Switch>   
                </div>
            </Router>                
        )
    }
}
export default connect()(RouteGuest)





// WEBPACK FOOTER //
// ./src/router.js